import { render, staticRenderFns } from "./getFromBazar.vue?vue&type=template&id=6fc566ca&"
import script from "./getFromBazar.vue?vue&type=script&lang=js&"
export * from "./getFromBazar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports